import React, { useState, useContext, useEffect, useMemo } from 'react';

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import Table from '#Table'
import Fab from '#Fab'

import { faEdit, faPlus, faTrash } from '@fortawesome/pro-regular-svg-icons'
import { Box } from '@mui/material';

const displayPerc = value => value
	? ((value/10000).toFixed(2).replace(/\./g, ",") + ' %')
	: '-'

const useTableDef = (categories, traders) => useMemo(() => ([
	{ label:"Descrizione", field:'label' },
	{ label:"Categoria", content:row => categories.find(cat => cat.value===row.productCategory)?.label || '???' },
	{ label:"Vendita nuovo?", field:'saleNew', type:'boolean' },
	{ label:"Vendita usato?", field:'saleUsed', type:'boolean' },
	{ label:"Nol. giornaliero?", field:'rentDaily', type:'boolean' },
	{ label:"Nol. mensile?", field:'rentMonthly', type:'boolean' },
	{ label:"% sconto", content:row => displayPerc(row?.discount) },
	{ label:"Commerciali", content:row =>
		row?.traders.map(trader => (
			<Box>{traders.find(scanItem => scanItem.value === trader)?.label || '???'}</Box>
		))
	},
]), [ categories, traders ])

export default function PromotionsList() {
	const api = useContext(APICtx)
	const [ ids, setIds ] = useState([])
	const [ categoriesOpts, setCategoriesOpts ] = useState()
	const [ traders, setTraders ] = useState([])
	const tableDef = useTableDef(categoriesOpts, traders)

	const handleDelete = ({ _id, label }) => {
		api.dialogConfirm({
			text: 'Sei sicuro di voler cancellare la promozione "'+label+'"?',
			onConfirm: () => api.call('promotions/del', { _id }).then(handleRefresh),
		})
	}
	const handleRefresh = () => api.call('promotions/list').then(setIds)
	useEffect(() => {
		api.call('products-categories/options').then(setCategoriesOpts)
		api.call('offers/listTraders').then(async tradersIds => {
			setTraders(await Promise.all(
				tradersIds.map(async uid => {
					const user = await api.auth.appUserGet(uid)
					return { value:uid, label:user?.displayName || user?.address || '-' }
				})
			))
		})
		handleRefresh()
	}, [])
	const getRow = _id => api.call('promotions/get', { _id })
	const defBtns = [
		{
			icon: faEdit,
			label: 'Modifica',
			linkTo: row => '/promotions/edit/'+row._id,
		},
		{ icon:faTrash, label:'Elimina', onClick:handleDelete },
	]

	return (
		<Tpl title='Gestione promozioni'>
			<Table def={tableDef} defBtns={defBtns} ids={ids} getRow={getRow} />
			<Fab label="Aggiungi promozione" icon={faPlus} linkTo="/promotions/edit" />
		</Tpl>
	)
}
